import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Quote, Star } from "lucide-react";

export const testimoniosData = [
  {
    quote:
      "Implementar crecelocal fue una de las mejores decisiones que tome para mi negocio.",
    name: "Gonzalo Arregui",
    role: "Arregui Premium",
    metric: "GESTIÓN CENTRALIZADA",
    initials: "GA",
    videoUrl:
      "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a2361436a06f03d447ae968.mp4",
  },
  {
    quote:
      "Nos pasaba que nos escribían a la noche y no le podíamos contestar, y a la mañana siguiente ese cliente ya había comprado en otro lado. Con CreceLocal eso dejó de pasar.",
    name: "Sebastian Hernandez",
    role: "Bass Materiales",
    metric: "ATENCIÓN 24/7",
    initials: "SB",
    videoUrl:
      "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a2361433c3faf82cae33e06.mp4",
  },
  {
    quote:
      "Teníamos 800 contactos durmiendo en un Excel. En 6 meses se reactivó la base y vendimos 12 departamentos. Pensábamos que teníamos que seguir metiendo pauta pero los clientes ya los teníamos.",
    name: "Facundo Stagnaro",
    role: "Hive Desarrollos",
    metric: "12 VENTAS CERRADAS / AÑO",
    initials: "FS",
    videoUrl: null,
  },
  {
    quote:
      "Con crecelocal pude automatizar mi proceso de venta - desde mi pagina web hasta las consultas que llegan por WhatsApp. Ahora cuando alguien quiere trabajar conmigo recibe respuesta automatica y seguimientos hasta que avanzan",
    name: "Rocío Otero",
    role: "DaleRocha - Estudio de diseño gráfico",
    metric: "PROCESO AUTOMATIZADO",
    initials: "RO",
    videoUrl: null,
  },
  {
    quote:
      "Aguante Crece local! Uso y recomiendo! Grandes soluciones para mi emprendimiento. Los chicos responden rápido y trabajan bien y con sus obejtivos claros. GRACIAS CRECE LOCAL crecemos todos 🫶",
    name: "Jimena",
    role: "AstrologiaSI - Formación Online",
    metric: "GRANDES SOLUCIONES",
    initials: "J",
    videoUrl: null,
  },
  {
    quote:
      "Quería dejar mi experiencia con CreceLocal, la verdad una atención especial , dedicación y acompañamiento en todo el proceso , con explicaciones claras y concretas , ideas creativas y sobretodo con costos súper accesibles , empresa con buen precio y calidad , la Súper recomiendo , gracias Crece Local por ayudarnos y acompañarnos con nuestro proyecto",
    name: "Mariela Palaciones",
    role: "Consultorios FIka",
    metric: "ATENCIÓN ESPECIAL",
    initials: "MP",
    videoUrl: null,
  },
  {
    quote:
      "Implementaron en mi empresa un sistema de CRM y un bot de respuestas con IA que me resolvio un problema recurrente de mensajes pendientes, colgados, sin respuesta. Gracias a esto alivianamos el trabajo de los vendedores y se volvio mas efectivo.",
    name: "Facundo Stagnaro",
    role: "Hive Desarrollos",
    metric: "TRABAJO MÁS EFECTIVO",
    initials: "FS",
    videoUrl: null,
  },
  {
    quote: "Muy buen servicio! Super atentos y estan siempre a la ayuda!",
    name: "Valentin Marino",
    role: "Agencia de Google y Meta ADS",
    metric: "SÚPER ATENTOS",
    initials: "VM",
    videoUrl: null,
  },
  {
    quote:
      "Los chicos hicieron un excelente trabajo y me implementaron todo el sistema en la gestoria, nos ayudo mucho a organizar a nuestros clientes. Gracias a la implementacion de un bot que responde todas las consultas a diario, pudimos dedicarle …Más",
    name: "Maité Fariello",
    role: "Gestoría Automor e Integral",
    metric: "SISTEMA IMPLEMENTADO",
    initials: "MF",
    videoUrl: null,
  },
];

export const TestimoniosCarousel = () => {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 sm:px-10 md:px-12 relative my-8 md:my-12">
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        className="w-full"
      >
        <CarouselContent>
          {testimoniosData.map((testimonial, index) => (
            <CarouselItem
              key={index}
              className="pl-4 md:basis-1/2 lg:basis-1/2"
            >
              <div className="p-1 h-full">
                <div
                  className="bg-[#0F0F11] border border-white/5 rounded-[16px] p-5 md:p-6 h-full flex flex-col justify-between hover:border-white/10 transition-all duration-300"
                  style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)" }}
                >
                  <div className="mb-4 md:mb-6">
                    <div className="flex items-center justify-between mb-3 md:mb-4">
                      <Quote className="w-6 h-6 md:w-8 md:h-8 text-[#7C3AED]/20" />
                      <div className="flex gap-1">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <Star
                            key={star}
                            className="w-3 h-3 md:w-4 md:h-4 fill-[#FBBF24] text-[#FBBF24]"
                          />
                        ))}
                      </div>
                    </div>
                    <p className="text-[#FAFAFA] text-[14px] md:text-[15px] leading-[1.5] md:leading-[1.6] italic">
                      "{testimonial.quote}"
                    </p>
                  </div>
                  <div className="flex items-center gap-2 md:gap-3">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-[#131316] border border-white/10 flex items-center justify-center shrink-0">
                      <span className="text-[#FAFAFA] font-medium text-[11px] md:text-[12px] tracking-wider">
                        {testimonial.initials}
                      </span>
                    </div>
                    <div>
                      <p className="text-[#FAFAFA] font-medium text-[13px] md:text-[14px] leading-tight">
                        {testimonial.name}
                      </p>
                      <p className="text-[#A1A1AA] text-[11px] md:text-[12px] leading-tight mt-0.5">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden sm:flex bg-[#0F0F11] border-white/10 text-white hover:bg-white/10 hover:text-white -left-2 md:-left-4 w-8 h-8 md:w-10 md:h-10" />
        <CarouselNext className="hidden sm:flex bg-[#0F0F11] border-white/10 text-white hover:bg-white/10 hover:text-white -right-2 md:-right-4 w-8 h-8 md:w-10 md:h-10" />
      </Carousel>
    </div>
  );
};
